import { BaseRequestModel } from "../RequestModel/BaseRequestModel";
import { BaseResponseModel } from "./BaseResponseModel";

export class LoginResponseModel extends BaseResponseModel {
    constructor(obj) {
        super(obj);
        this.UserName = obj.UserName;
        this.CompanyCode = obj.CompanyCode;
        this.CompanyName = obj.CompanyName;
    }

    CreateBaseRequestModel() {
        return new BaseRequestModel({
            AccessKey: this.AccessKey,
            RequestKey: this.RequestKey
        });
    }
}